import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import "./Addstudent.css";

const API_URL = "https://aadyaacademy.org/api";

function Addstudent({ handleCancel, fetchData, editingStudent }) {
  const [newStudent, setNewStudent] = useState({
    student_id: "",
    student_name: "",
    student_aadhar: "",
    class: "",
    section: "",
    gender: "",
    dob: "",
    student_blood_group: "",
    academic_year_joined: "",
    caste: "",
    nationality: "",
    mother_tongue: "",
    address: "",
    home_town: "",
    father_name: "",
    father_phone: "",
    father_email: "",
    father_occupation: "",
    father_aadhar: "",
    mother_name: "",
    mother_email: "",
    mother_phone: "",
    mother_occupation: "",
    mother_aadhar: "",
    guardian_name: "",
    guardian_phone: "",
    guardian_email: "",
    guardian_aadhar: "",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (editingStudent) {
      console.log("Editing student:", editingStudent);
      const normalizedGender = editingStudent.gender === "M" ? "male" : editingStudent.gender === "F" ? "female" : "";
      setNewStudent({
        student_id: editingStudent.student_id || "",
        student_name: editingStudent.student_name || "",
        student_aadhar: editingStudent.student_aadhar || "",
        class: editingStudent.class || "",
        section: editingStudent.section || "",
        gender: normalizedGender,
        dob: editingStudent.dob || "",
        student_blood_group: editingStudent.student_blood_group || "",
        academic_year_joined: editingStudent.academic_year_joined || "",
        caste: editingStudent.caste || "",
        nationality: editingStudent.nationality || "",
        mother_tongue: editingStudent.mother_tongue || "",
        address: editingStudent.address || "",
        home_town: editingStudent.home_town || "",
        father_name: editingStudent.father_name || "",
        father_phone: editingStudent.father_phone || "",
        father_email: editingStudent.father_email || "",
        father_occupation: editingStudent.father_occupation || "",
        father_aadhar: editingStudent.father_aadhar || "",
        mother_name: editingStudent.mother_name || "",
        mother_email: editingStudent.mother_email || "",
        mother_phone: editingStudent.mother_phone || "",
        mother_occupation: editingStudent.mother_occupation || "",
        mother_aadhar: editingStudent.mother_aadhar || "",
        guardian_name: editingStudent.guardian_name || "",
        guardian_phone: editingStudent.guardian_phone || "",
        guardian_email: editingStudent.guardian_email || "",
        guardian_aadhar: editingStudent.guardian_aadhar || "",
      });
    }
  }, [editingStudent]);

  useEffect(() => {
    const fetchClassesAndSections = async () => {
      try {
        const [classResponse, sectionResponse] = await Promise.all([
          axios.get(`${API_URL}/classes`),
          axios.get(`${API_URL}/sections`),
        ]);
        setClasses(classResponse.data?.classes || []);
        setSections(sectionResponse.data?.sections || []);
      } catch (error) {
        console.error("Error fetching classes and sections:", error);
        toast.error("Failed to load classes and sections", { autoClose: 2000 });
      }
    };
    fetchClassesAndSections();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`${name}: ${value}`);
    setNewStudent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSize = file.size / 1024 / 1024; // size in MB
      const allowedTypes = ["image/jpeg", "image/png"];
      if (fileSize > 2) {
        toast.error("File size should not exceed 2MB", { autoClose: 2000 });
        return;
      }
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPEG and PNG files are allowed", { autoClose: 2000 });
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClear = () => {
    setNewStudent({
      student_id: "",
      student_name: "",
      student_aadhar: "",
      class: "",
      section: "",
      gender: "",
      dob: "",
      student_blood_group: "",
      academic_year_joined: "",
      caste: "",
      nationality: "",
      mother_tongue: "",
      address: "",
      home_town: "",
      father_name: "",
      father_phone: "",
      father_email: "",
      father_occupation: "",
      father_aadhar: "",
      mother_name: "",
      mother_email: "",
      mother_phone: "",
      mother_occupation: "",
      mother_aadhar: "",
      guardian_name: "",
      guardian_phone: "",
      guardian_email: "",
      guardian_aadhar: "",
    });
    setImagePreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...newStudent,
        gender: newStudent.gender === "male" ? "M" : newStudent.gender === "female" ? "F" : "",
      };
      console.log("Submitting payload:", payload);

      if (editingStudent) {
        await axios.put(`${API_URL}/students/${editingStudent.student_id}`, payload);
        toast.success("Student updated successfully!", { autoClose: 2000 });
      } else {
        await axios.post(`${API_URL}/students`, payload);
        toast.success("Student added successfully!", { autoClose: 2000 });
      }
      fetchData();
      handleCancel();
    } catch (error) {
      console.error("Error saving student:", error);
      if (error.response?.status === 409) {
        toast.error(error.response.data.message || "Student ID already exists!", { autoClose: 2000 });
      } else if (error.response?.status === 400) {
        toast.error(error.response.data.message || "Invalid data provided!", { autoClose: 2000 });
      } else {
        toast.error("Error saving student! Please try again.", { autoClose: 2000 });
      }
    }
  };

  const currentYear = new Date().getFullYear();
  const academicYearJoined = Array.from(
    { length: 7 },
    (_, i) => `${currentYear - 5 + i}-${currentYear - 4 + i}`
  );

  return (
    <div className="add-student-container">
      <div className="add-stu-c">
        <h2>{editingStudent ? "Edit Student" : "Add New Student"}</h2>
        <form onSubmit={handleSubmit}>
          <div className="add-img">
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Image Preview"
                style={{
                  width: "150px",
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              />
            ) : (
              <p>No image selected</p>
            )}
            <input
              type="file"
              name="studentPic"
              accept="image/*"
              onChange={handleImageChange}
            />
          </div>
          <div className="ad-f-n">
            <div className="stu-id">
              <h4>
                Student ID <FontAwesomeIcon icon={faStar} className="stu-icon" />
              </h4>
              <input
                className="studentId"
                type="text"
                name="student_id"
                value={newStudent.student_id}
                onChange={(e) => {
                  let value = e.target.value.replace(/[^0-9/-]/g, "");
                  if (value.length > 3 && value.charAt(3) !== "/") {
                    value = value.slice(0, 3) + "/" + value.slice(3);
                  }
                  if (value.length > 8 && value.charAt(8) !== "-") {
                    value = value.slice(0, 8) + "-" + value.slice(8);
                  }
                  if (value.length > 11) {
                    value = value.slice(0, 11);
                  }
                  handleInputChange({ target: { name: "student_id", value } });
                }}
                placeholder="200/2024-25"
                required
              />
            </div>
            <div className="stu-name">
              <h4>
                Student Name <FontAwesomeIcon icon={faStar} className="stu-icon" />
              </h4>
              <input
                className="studentname"
                type="text"
                name="student_name"
                value={newStudent.student_name}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "student_name", value: e.target.value.replace(/\d/g, "") },
                  })
                }
                placeholder="Enter"
                required
              />
            </div>
            <div className="stu-aadhar">
              <h4>Student Aadhar Number</h4>
              <input
                className="studentAadhar"
                type="text"
                name="student_aadhar"
                value={newStudent.student_aadhar}
                onChange={(e) => {
                  if (/^\d{0,12}$/.test(e.target.value)) {
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter"
                maxLength={12}
                inputMode="numeric"
              />
            </div>
            <div className="stu-class">
              <h4>
                Class <FontAwesomeIcon icon={faStar} className="stu-icon" />
              </h4>
              <select
                className="classname"
                name="class"
                value={newStudent.class}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Class</option>
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.name}>
                    {cls.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="stu-section">
              <h4>Section</h4>
              <select
                className="section"
                name="section"
                value={newStudent.section}
                onChange={handleInputChange}
              >
                <option value="">Select Section</option>
                {sections.map((section) => (
                  <option key={section.id} value={section.name}>
                    {section.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="c-g-d">
            <div className="stu-gender">
              <h4>
                Gender <FontAwesomeIcon icon={faStar} className="stu-icon" />
              </h4>
              <select
                className="gender"
                name="gender"
                value={newStudent.gender}
                onChange={handleInputChange}
                required
              >
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div className="stu-dob">
              <h4>
                Date of Birth <FontAwesomeIcon icon={faStar} className="stu-icon" />
              </h4>
              <input
                className="datepicker"
                type="date"
                name="dob"
                value={newStudent.dob}
                onChange={handleInputChange}
                max={new Date().toISOString().split("T")[0]}
                required
              />
            </div>
            <div className="stu-blood">
              <h4>Blood Group</h4>
              <input
                className="studentBloodGroup"
                type="text"
                name="student_blood_group"
                value={newStudent.student_blood_group}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  if (/^(A|B|AB|O)?[+-]?$/.test(value)) {
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter"
              />
            </div>
          </div>
          <div className="c-n-m">
            <div className="stu-academic">
              <h4>
                Joined Academic Year <FontAwesomeIcon icon={faStar} className="stu-icon" />
              </h4>
              <select
                className="academicJoined"
                name="academic_year_joined"
                value={newStudent.academic_year_joined}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Joined Academic Year</option>
                {academicYearJoined.map((yearRange) => (
                  <option key={yearRange} value={yearRange}>
                    {yearRange}
                  </option>
                ))}
              </select>
            </div>
            <div className="stu-caste">
              <h4>Caste</h4>
              <select
                className="caste"
                name="caste"
                value={newStudent.caste}
                onChange={handleInputChange}
              >
                <option value="">Select</option>
                <option value="General">General</option>
                <option value="SC">SC</option>
                <option value="ST">ST</option>
                <option value="OBC">OBC</option>
              </select>
            </div>
            <div className="stu-nationality">
              <h4>Nationality</h4>
              <input
                className="nationality"
                type="text"
                name="nationality"
                value={newStudent.nationality}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "nationality", value: e.target.value.replace(/\d/g, "") },
                  })
                }
                placeholder="Enter"
              />
            </div>
            <div className="stu-mother-tongue">
              <h4>Mother Tongue</h4>
              <input
                className="motherTongue"
                type="text"
                name="mother_tongue"
                value={newStudent.mother_tongue}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "mother_tongue", value: e.target.value.replace(/\d/g, "") },
                  })
                }
                placeholder="Enter"
              />
            </div>
          </div>
          <div className="h-a">
            <div className="stu-address">
              <h4>Address</h4>
              <textarea
                className="address"
                name="address"
                value={newStudent.address}
                onChange={handleInputChange}
                placeholder="Enter"
              />
            </div>
          </div>
          <div className="h-a">
            <div className="stu-hometown">
              <h4>Home Town</h4>
              <input
                className="homeTown"
                type="text"
                name="home_town"
                value={newStudent.home_town}
                onChange={handleInputChange}
                placeholder="Enter"
              />
            </div>
          </div>
          <div className="parent">
            <div className="parent-left">
              <div className="stu-father-name">
                <h4>
                  Father's Name <FontAwesomeIcon icon={faStar} className="stu-icon" />
                </h4>
                <input
                  className="fathername"
                  type="text"
                  name="father_name"
                  value={newStudent.father_name}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "father_name", value: e.target.value.replace(/\d/g, "") },
                    })
                  }
                  placeholder="Enter"
                  required
                />
              </div>
              <div className="stu-father-phone">
                <h4>
                  Father's Phone Number <FontAwesomeIcon icon={faStar} className="stu-icon" />
                </h4>
                <input
                  className="fatherphone"
                  type="text"
                  name="father_phone"
                  value={newStudent.father_phone}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                  maxLength={10}
                  required
                />
              </div>
              <div className="stu-father-email">
                <h4>Father's Email</h4>
                <input
                  className="fatheremail"
                  type="email"
                  name="father_email"
                  value={newStudent.father_email}
                  onChange={handleInputChange}
                  placeholder="Enter"
                />
              </div>
              <div className="stu-father-occupation">
                <h4>Father's Occupation</h4>
                <input
                  className="fatherOccupation"
                  type="text"
                  name="father_occupation"
                  value={newStudent.father_occupation}
                  onChange={(e) => {
                    if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                />
              </div>
              <div className="stu-father-aadhar">
                <h4>Father's Aadhar Number</h4>
                <input
                  className="fatherAadhar"
                  type="text"
                  name="father_aadhar"
                  value={newStudent.father_aadhar}
                  onChange={(e) => {
                    if (/^\d{0,12}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                  maxLength={12}
                />
              </div>
            </div>
            <div className="parent-mid">
              <div className="stu-mother-name">
                <h4>Mother's Name</h4>
                <input
                  className="motherName"
                  type="text"
                  name="mother_name"
                  value={newStudent.mother_name}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "mother_name", value: e.target.value.replace(/\d/g, "") },
                    })
                  }
                  placeholder="Enter"
                />
              </div>
              <div className="stu-mother-phone">
                <h4>Mother's Phone Number</h4>
                <input
                  className="motherPhone"
                  type="text"
                  name="mother_phone"
                  value={newStudent.mother_phone}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                  maxLength={10}
                />
              </div>
              <div className="stu-mother-email">
                <h4>Mother's Email</h4>
                <input
                  className="motherEmail"
                  type="email"
                  name="mother_email"
                  value={newStudent.mother_email}
                  onChange={handleInputChange}
                  placeholder="Enter"
                />
              </div>
              <div className="stu-mother-occupation">
                <h4>Mother's Occupation</h4>
                <input
                  className="motherOccupation"
                  type="text"
                  name="mother_occupation"
                  value={newStudent.mother_occupation}
                  onChange={(e) => {
                    if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                />
              </div>
              <div className="stu-mother-aadhar">
                <h4>Mother's Aadhar Number</h4>
                <input
                  className="motherAadhar"
                  type="text"
                  name="mother_aadhar"
                  value={newStudent.mother_aadhar}
                  onChange={(e) => {
                    if (/^\d{0,12}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                  maxLength={12}
                />
              </div>
            </div>
            <div className="parent-right">
              <div className="stu-guardian-name">
                <h4>Guardian's Name</h4>
                <input
                  className="guardianName"
                  type="text"
                  name="guardian_name"
                  value={newStudent.guardian_name}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "guardian_name", value: e.target.value.replace(/\d/g, "") },
                    })
                  }
                  placeholder="Enter"
                />
              </div>
              <div className="stu-guardian-phone">
                <h4>Guardian's Phone Number</h4>
                <input
                  className="guardianPhone"
                  type="text"
                  name="guardian_phone"
                  value={newStudent.guardian_phone}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                  maxLength={10}
                />
              </div>
              <div className="stu-guardian-email">
                <h4>Guardian's Email</h4>
                <input
                  className="guardianEmail"
                  type="email"
                  name="guardian_email"
                  value={newStudent.guardian_email}
                  onChange={handleInputChange}
                  placeholder="Enter"
                />
              </div>
              <div className="stu-guardian-aadhar">
                <h4>Guardian's Aadhar Number</h4>
                <input
                  className="guardianAadhar"
                  type="text"
                  name="guardian_aadhar"
                  value={newStudent.guardian_aadhar}
                  onChange={(e) => {
                    if (/^\d{0,12}$/.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                  placeholder="Enter"
                  maxLength={12}
                />
              </div>
            </div>
          </div>
          <div className="add-stu-btn">
            <button className="add-stu-btn-submit" type="submit">
              {editingStudent ? "Update" : "Add"}
            </button>
            <button
              className="add-stu-btn-clear"
              type="button"
              onClick={handleClear}
            >
              Clear
            </button>
            <button
              className="add-stu-btn-cancel"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}

export default Addstudent;